export default __webpack_public_path__ + "static/fv-nr-3-4b87856556b8c6513dc99f72627d08fa.png";